export default import.meta.ROLLDOWN_FILE_URL_nJkgIVJgL11RgZiGUBj6wA